const INTEGRATION_TESTING_ORG = 'integrationtesting';

export default function isIntegrationTesting(): boolean {
  const org = window.localStorage.getItem('organisation');
  return org === INTEGRATION_TESTING_ORG;
}
